import './Pager.css'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faChevronLeft, faChevronRight} from '@fortawesome/free-solid-svg-icons'

function Pager(props) {
    return(
        props.count
        ?
        <div className='pager'>
            <button onClick={() => props.setPage(props.page-1)} disabled={props.page == 0}><div><FontAwesomeIcon icon={faChevronLeft}/> Indietro</div></button>
            <div><div>{props.page+1} di {Math.ceil(props.count/props.pageSize)}</div></div>
            <button onClick={() => props.setPage(props.page+1)} disabled={!(props.count > props.pageSize && props.page < (Math.ceil(props.count/props.pageSize)-1))}><div>Avanti <FontAwesomeIcon icon={faChevronRight}/></div></button>
        </div>
        :
        <></>
    )
}

export default Pager